<script>
import { ValidationObserver } from 'vee-validate';
import { nextTick } from 'vue';
import CompanyDetailsFields from './company_details_fields.vue';

export default {
  name: 'CompanyDetailsForm',
  components: {
    CompanyDetailsFields,
    ValidationObserver,
  },
  props: {
    initialFormData: {
      type: Object,
      required: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    // Note that we are passing this to the `optional` field and updating `optional-text` to "(required)"
    // This is not used for any validation purposes and is only used to display the label content
    showRequiredLabels: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedCountry: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        companyName: this.initialFormData.companyName,
        taxId: this.initialFormData.taxId,
      },
    };
  },
  methods: {
    async handleFormValueChange(updatedForm) {
      this.form = updatedForm;
      // nextTick is needed because we need to wait for the ValidationObserver
      // be re-rendered before validating the form to get the latest validation state
      await nextTick();
      const isValid = await this.$refs.companyFormObserver.validate({ silent: true });
      this.$emit('change', this.form, isValid);
    },
  },
  i18n: {
    title: 'Company details',
  },
};
</script>

<template>
  <div data-testid="company-details-form" class="jh-hidden">
    <h3 v-if="showHeader" class="gl-mb-5">{{ __($options.i18n.title) }}</h3>
    <validation-observer ref="companyFormObserver" slim>
      <company-details-fields
        :initial-form-data="form"
        :show-required-labels="showRequiredLabels"
        :selected-country="selectedCountry"
        @change="handleFormValueChange"
      />
    </validation-observer>
  </div>
</template>
